import { OUTCOMES, TONE } from "./importOutcomes";

// Separate, clickable totals; clicking one filters the results table.
export const ImportSummaryBar = ({ summary, active, onPick }) => (
    <div className="space-y-2" data-testid="import-summary">
        <div className="text-sm text-gray-700" data-testid="import-summary-line">
            {Object.keys(OUTCOMES).filter((k) => summary[k]).map((k) => `${summary[k].toLocaleString()} ${(summary[k] === 1 ? OUTCOMES[k].short : OUTCOMES[k].label).toLowerCase()}`).join(" · ") || "No rows"}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {Object.entries(OUTCOMES).map(([k, o]) => (
                <button
                    key={k}
                    type="button"
                    onClick={() => onPick(k)}
                    className={`text-left border rounded-md px-3 py-2 transition-shadow hover:shadow-sm ${TONE[o.tone]} ${active === k ? "ring-2 ring-offset-1 ring-gray-900/40" : ""}`}
                    data-testid={`summary-${k}`}
                >
                    <div className="text-[11px] uppercase tracking-wider opacity-80">{o.label}</div>
                    <div className="text-xl font-display font-semibold tabular" data-testid={`summary-${k}-count`}>{(summary[k] || 0).toLocaleString()}</div>
                </button>
            ))}
        </div>
    </div>
);
